import React from 'react'
import map from 'lodash/map'

export default ({
  summariesWithCounts,
  areaTypeAreaCount,
}) => (
  <div className='service-summaries list'>
    {summariesWithCounts.map(summaryWithCounts =>
      <div className='service-summary card no-bg' key={summaryWithCounts.areaTypeName}>
        <strong>{areaTypeAreaCount[summaryWithCounts.areaTypeName]} {summaryWithCounts.areaTypeName}</strong>

        {map(summaryWithCounts.services, (counts, service) => <p key={service}>({counts.aggregatedQuantity}x) {service}</p>)}
      </div>
    )}
  </div>
)



// WEBPACK FOOTER //
// ./src/components/service-summaries/service-summaries.js